var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sparkline"},[_c('e-chart',{staticStyle:{"width":"90%","max-width":"90%","min-height":"90%","max-height":"90%"},attrs:{"options":_vm.config,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }